import $ from "jquery"

$(function() {
  $(document).on('click', 'a[disabled=disabled]', (e) => {
    e.preventDefault(); // Prevent link from following its href
  });
});
